export default __webpack_public_path__ + "static/media/logo_magical_shuttle.0bd9e59d.jpg";